import { Grid, TextField } from "@material-ui/core";
import { Autocomplete } from "@material-ui/lab";
import React, { forwardRef, useEffect, useImperativeHandle, useRef } from "react";
import { Controller, useForm } from "react-hook-form";

const PartForm = forwardRef((props, ref) => {
  const { onSubmitForm, defaultValues = [], loading = false, type = "part" } = props;

  const {
    control,
    handleSubmit,
    formState: { errors, isSubmitSuccessful },
  } = useForm({
    defaultValues: defaultValues,
  });

  useImperativeHandle(ref, () => ({
    submit: () => handleSubmit(onSubmitForm)(),
    isSubmitSuccessful: () => isSubmitSuccessful,
  }));

  const partOptions = [
    "زمین موجود",
    "زیر زمین",
    "سرپله و بالایی",
    "پارکینگ",
    "اشجار",
    "استخر",
    "دیوار کشی",
    "همکف",
    "‌طبقه اول",
    "طبقه دوم",
    "طبقه سوم",
    "طبقه چهارم",
  ];
  const creditOptions = ["آب", "گاز", "‌برق", "تلفن", "کولر"];

  const validate = (evt) => {
    var theEvent = evt || window.event;
    var key;
    // Handle paste
    if (theEvent.type === "paste") {
      key = theEvent.clipboardData.getData("text/plain");
    } else {
      // Handle key press
      key = theEvent.keyCode || theEvent.which;
      key = String.fromCharCode(key);
    }
    var regex = /[^0-9۰-۹.]/g;
    if (regex.test(key)) {
      theEvent.returnValue = false;
      if (theEvent.preventDefault) theEvent.preventDefault();
    }
  };

  return (
    <form onSubmit={handleSubmit(onSubmitForm)}>
      <Grid container direction='row' spacing={1}>
        <Grid item xs={12}>
          <Controller
            name='name'
            control={control}
            rules={{ required: true }}
            render={({ field }) => (
              <Autocomplete
                {...field}
                freeSolo
                options={type === "part" ? partOptions : creditOptions}
                renderInput={(params) => (
                  <TextField
                    {...params}
                    label={`نام ${type === `part` ? `بخش` : `امتیاز`}`}
                    size='small'
                    variant='outlined'
                    margin='dense'
                    fullWidth
                    error={errors.name}
                    helperText={errors.name && "فیلد نمیتواند خالی باشد"}
                  />
                )}
                inputValue={field?.value}
                onInputChange={(data) => field.onChange(data?.target?.value)}
                onChange={(_, data) => field.onChange(data)}
              />
            )}
          />
        </Grid>

        <Grid item xs={12}>
          <Controller
            name='amount'
            control={control}
            rules={{ required: true }}
            render={({ field }) => (
              <TextField
                {...field}
                label={`${type === `part` ? `مساحت بخش` : `تعداد امتیاز`}`}
                size='small'
                margin='dense'
                variant='outlined'
                // type='number'
                error={errors.amount}
                helperText={errors.amount && "فیلد نمیتواند خالی باشد"}
                onKeyPress={validate}
                onChange={(e) => field.onChange({ ...e, target: { value: e?.target?.value?.toEnglishDigits() } })}
                value={field?.value?.toPersianDigits()}
                fullWidth
              />
            )}
          />
        </Grid>

        {type === "part" && (
          <Grid item xs={12}>
            <Controller
              name='value'
              control={control}
              rules={{ required: true }}
              render={({ field }) => (
                <TextField
                  {...field}
                  label='ارزش بخش'
                  size='small'
                  margin='dense'
                  variant='outlined'
                  // type='number'
                  onKeyPress={validate}
                  error={errors.value}
                  helperText={errors.value && "فیلد نمیتواند خالی باشد"}
                  fullWidth
                  onChange={(e) =>
                    field.onChange({
                      ...e,
                      target: { value: e?.target?.value?.split(",")?.join("")?.toEnglishDigits() },
                    })
                  }
                  value={field?.value?.toString()?.toCurrencyFormat()?.toPersianDigits()}
                />
              )}
            />
          </Grid>
        )}

        <Grid item xs={12}>
          <Controller
            name='description'
            control={control}
            render={({ field }) => (
              <TextField
                {...field}
                label='توضیحات'
                size='small'
                margin='dense'
                variant='outlined'
                error={errors.description}
                helperText={errors.description && "فیلد نمیتواند خالی باشد"}
                fullWidth
                onChange={(e) => field.onChange({ ...e, target: { value: e?.target?.value?.toEnglishDigits() } })}
                value={field?.value?.toPersianDigits()}
              />
            )}
          />
        </Grid>
      </Grid>
    </form>
  );
});

export default PartForm;
